import { getConfigsFromTypedField } from '.';

import { ISPConfigMappers } from 'common/dynamic-form/services/loader/model/config-mapper.interface';
import { getPageGroupConfig } from 'common/dynamic-form/types/group/group.utils';
import { getToolbarConfig } from 'common/dynamic-form/types/toolbar/toolbar.utils';
import { getWizardConfig } from 'common/dynamic-form/types/wizard/wizard.utils';

import { wrappConfigsIntoInlineGroup } from './wrapp-configs-into-inline-group';

import { ISPFieldConfig, ISPFormState } from '../../model';
import { TypedForm } from '../form-preparing';

/**
 * Get configs list for pages
 *
 * @param typedForm - typed doc
 * @param state - dynamic form state
 * @param mappers
 */
export function getConfigsFromTypedForm(
  typedForm: TypedForm | undefined,
  state: ISPFormState,
  mappers?: Partial<ISPConfigMappers>,
): ISPFieldConfig[] {
  if (!typedForm) {
    return [];
  }

  const configs: ISPFieldConfig[] = [];
  if (typedForm.pages) {
    configs.push(
      ...typedForm.pages.map(page => {
        const pageConfigs = page.fields
          .map(field => {
            const fieldConfigs = getConfigsFromTypedField(
              field,
              state,
              mappers,
            );

            return wrappConfigsIntoInlineGroup(
              fieldConfigs,
              field.field,
              state,
            );
          })
          .flat();

        return getPageGroupConfig(pageConfigs, state, page.page);
      }),
    );
  }
  if (typedForm.fields) {
    configs.push(
      ...typedForm.fields
        .map(field => {
          const fieldConfigs = getConfigsFromTypedField(field, state, mappers);

          return wrappConfigsIntoInlineGroup(fieldConfigs, field.field, state);
        })
        .flat(),
    );
  }
  const wizardConfig = getWizardConfig(state);
  if (wizardConfig) {
    configs.push(wizardConfig);
  }
  const toolbarConfig = getToolbarConfig(state);
  if (toolbarConfig) {
    configs.push(toolbarConfig);
  }

  return configs.filter(Boolean);
}
